import ApiService from '@/services/apiService';
import orderBy from 'lodash/orderBy';

export default {
  data() {
    return {
      // make sure these are set in the used component or as prop (like in packet-history-viewer.vue)
      // queryStartDate: new Date(new Date() - 86400000),
      // queryEndDate: new Date(),
    };
  },
  computed: {
    queryItemsInflux() {
      let timeRangeQueryItems = {
        and: [],
      };
      if (this.queryStartDate) {
        timeRangeQueryItems.and.push(this.queryItemDate(this.queryStartDate, 'gte', 'influx'));
      } else {
        timeRangeQueryItems.and.push(this.queryItemDate(null, 'gte', 'influx'));
      }
      if (this.queryEndDate) {
        timeRangeQueryItems.and.push(this.queryItemDate(this.queryEndDate, 'lte', 'influx'));
      } else {
        timeRangeQueryItems.and.push(this.queryItemDate(null, 'lte', 'influx'));
      }
      if (timeRangeQueryItems.and.length === 0) {
        timeRangeQueryItems = undefined;
      }
      return timeRangeQueryItems;
    },
  },
  methods: {
    queryItemDate(value, operator, db) {
      return { path: this.queryOrderKeyForColumn('time', db), operator, value };
    },
    queryOrderKeyForColumn(column, db) {
      switch (column) {
        case 'time':
          return db === 'influx' ? '_time' : 'timestamp';
        case 'value':
          return db === 'influx' ? '_value' : 'value.value';
        default:
          return column;
      }
    },
    loadDetailledHistoryData(stateId, dtwinId, sortItem, sortDirection, usedPage, usedItemsPerPage) {
      // A note about the following process:
      // ALL state-entries are always persisted to Influx, but not in their entirety (aka max 255 chars off of JSON-strings)
      // so firstly query all states from Influx, which should be done fairly performantly
      // If not all the data fits into the influx-value-field (a string or json with more than 255 chars),
      // then it was persisted to Postgres first and the postgres-state-history-UUID got tagged on the Influx-entry
      // thus, after fetching from Influx, enrich those entries by directly querying the UUIDs from Postgres
      // ----
      // before that, the Postgres was queried with a search by stateId and time-range, which was okayish until it wasn't,
      // growing near to a billion entries in Postgres. Thus, not all data is persisted in Postgres any more if not needed,
      // but also querying directly via UUID would still be performant enough even for a billion entries
      // ----
      // some of the following should be slightly refactored once the feature-flag goes live,
      // remove digitalTwinStatesSearch and following processing in favour of digitalTwinStatesHistoryFetchByUuid

      return ApiService.influxStatesInfluxSearch(
        this,
        [dtwinId],
        [stateId],
        this.queryItemsInflux,
        usedPage * usedItemsPerPage,
        usedItemsPerPage,
        [{ path: this.queryOrderKeyForColumn(sortItem, 'influx'), direction: sortDirection }]
      )
        .then((tableResponse) => {
          let postgresResponsePromise = [];
          // items from influx with postgres_id tag shall be queried from postgres directly
          // the other ones should be complete with information (or too old before this whole "migration",
          // but in that case we do not care, the customer can just suck it)
          const postgresIds = tableResponse.history.filter((i) => !!i.meta.postgresId).map((i) => i.meta.postgresId);
          if (postgresIds.length > 0) {
            postgresResponsePromise = ApiService.digitalTwinStatesHistoryFetchByUuid(this, postgresIds);
          }
          return Promise.all([Promise.resolve(tableResponse), postgresResponsePromise]);
        })
        .then((tableResponse) => {
          let packetHistory = tableResponse[0].history
            .map((item) => {
              if (!!item.meta.postgresId) {
                // hot-swap the item with the complete postgres value
                const pgMatch = tableResponse[1].find((pgItem) => pgItem.id === item.meta.postgresId);
                if (pgMatch) {
                  return pgMatch;
                }
              }
              let parsedValue = item.value.value;
              try {
                parsedValue = item.value.value.constructor === Object ? item.value.value : JSON.parse(item.value.value);
              } catch (e) {
                // could not parse, leave the original value instead of return nothing
              }
              return {
                ...item,
                value: {
                  ...item.value,
                  // all queried data from influx is a string, so parse EVERYTHING
                  value: parsedValue,
                },
              };
            })
            .map((item) => ({
              time: item.value.time,
              value: item.value.value,
            }));
          return {
            totalCount: tableResponse[0].totalCount,
            items: orderBy(packetHistory, sortItem, [sortDirection.toLowerCase()]),
          };
        });
    },
  },
};
